<template>
  <v-layout column align-center class="settings-page">
    <v-card id="settings" class="settings-card mx-auto mb-5" flat>
      <v-card-title class="settings-card__header">
        <mrx-translation token="app.settings.title"></mrx-translation>
      </v-card-title>

      <v-list class="assessment-light panel-opaque py-0">
        <template v-for="(section, index) in visibleSections">
          <v-list-item
            :id="`settings-row-${section.id}`"
            :key="section.id"
            class="settings-row"
            @click="open(section.route)"
          >
            <v-list-item-content>
              <v-list-item-title class="settings-row__title">
                <mrx-translation :token="section.titleToken"></mrx-translation>
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon class="settings-row__chevron">
              <v-icon>{{ icons.mdiChevronRight }}</v-icon>
            </v-list-item-icon>
          </v-list-item>
          <v-divider
            v-if="index < visibleSections.length - 1"
            :key="`${section.id}-divider`"
            class="settings-divider"
          ></v-divider>
        </template>
      </v-list>
    </v-card>
  </v-layout>
</template>

<script>
import { mapState } from 'pinia'
import icons from '@/mixins/icons'
import { useLaunchSetupStore } from '@/stores/LaunchSetup'
import { useLanguageStore } from '@/stores/language'
import { usePartnerConfigStore } from '@/stores/partnerConfig'
import './styles/settings.css'

export default {
  name: 'Settings',
  mixins: [icons],
  computed: {
    sections() {
      return [
        {
          id: 'user_preferences',
          titleToken: 'app.summary.user.title',
          route: this.isSetupComplete
            ? { path: '/preference/summary', query: { setup: 'true' } }
            : this.entryRoute,
          show: !this.isSetupComplete || this.summaryCollection.length > 0,
        },
        {
          id: 'user_interface',
          titleToken: 'app.settings.user_interface.title',
          route: { name: 'UserInterface' },
          show: this.languages.length > 1 || this.editUserInterface,
        },
        {
          id: 'system_information',
          titleToken: 'app.device.title',
          route: { name: 'Device' },
          show: true,
        },
      ]
    },
    visibleSections() {
      return this.sections.filter(section => section.show)
    },
    ...mapState(useLaunchSetupStore, ['summaryCollection', 'isSetupComplete', 'entryRoute']),
    ...mapState(useLanguageStore, { languages: 'all' }),
    ...mapState(usePartnerConfigStore, ['editUserInterface']),
  },
  methods: {
    open(route) {
      this.$router.push(route).catch(error => {
        if (error.name !== 'NavigationDuplicated') throw error
      })
    },
  },
}
</script>
